export { default } from './FileUploadDropAreaWithAttachmentList';
